import React from 'react';
import styled from 'styled-components';
import Link from './Link';
import horizontallyCenteredSection from './styles/horizontallyCenteredSection';
import FacebookIcon from './Svg/FacebookIcon';
import InstagramIcon from './Svg/InstagramIcon';
import LinkedInIcon from './Svg/LinkedInIcon';
import SvgLogotype from './Svg/Logotype';
import RedditIcon from './Svg/RedditIcon';
import TwitterIcon from './Svg/TwitterIcon';

const Menu = styled.nav`
  ${horizontallyCenteredSection}
  height: 5rem;
  display: flex;
  align-items: center;
  background-color: var(--color-grey-1);
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-left: auto;
  align-items: center;

  a {
    line-height: 0;
  }

  @media (min-width: 768px) {
    margin-left: 0;
  }
`;

const BuilderLink = styled.a`
  display: none;
  margin-right: 2rem;
  color: var(--color-fluor-green);
  text-transform: uppercase;
  text-decoration: none;

  @media (min-width: 768px) {
    display: block;
    margin-left: auto;
  }
`;

const Marquee = styled.section`
  background-color: var(--color-fluor-orange);
  color: white;
  font-family: helvetica;
  text-transform: uppercase;
  overflow: hidden;

  div {
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    min-width: 100%;

    section {
      display: flex;
      flex-shrink: 0;
      height: 2.5rem;
      align-items: center;
      animation: slide-left 60s linear infinite;
      animation-play-state: running;

      p {
        font-size: 1rem;
        font-weight: bolder;
        padding-left: 0.5rem;
        font-family: 'NB Architekt', 'NB Grotesk', sans-serif;
        color: var(--color-black);
        cursor: default;
      }

      @keyframes slide-left {
        from {
          -webkit-transform: translateX(0);
          transform: translateX(0);
        }
        to {
          -webkit-transform: translateX(-100%);
          transform: translateX(-100%);
        }
      }
    }
  }

  &:hover {
    div {
      section {
        animation-play-state: paused;
      }
    }
  }
`;

function Navbar() {
  return (
    <>
      <Menu role="navigation">
        <Link to="/">
          <SvgLogotype />
        </Link>

        <BuilderLink href="/builder">Create your Artema Diana now</BuilderLink>

        <SocialLinks>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/artemacorp"
          >
            <InstagramIcon />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/Artema-Corp-111784757242101"
          >
            <FacebookIcon />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://twitter.com/ArtemaCorp"
          >
            <TwitterIcon />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/company/artema-corp"
          >
            <LinkedInIcon />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.reddit.com/user/ArtemaCorp"
          >
            <RedditIcon />
          </a>
        </SocialLinks>
      </Menu>
      <Marquee aria-hidden="true" data-nosnippet>
        <div>
          <section>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
          </section>
          <section>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
            <p>Better gamers deserve better tools //</p>
          </section>
        </div>
      </Marquee>
    </>
  );
}

export default Navbar;
